export default class ThingDetailLabelsController {
    /** @ngInject */
    constructor(EventEmitter, FolderService) {
        this.eventEmitter = EventEmitter;
        this.FolderService = FolderService;
    }

    onFolderChanged({ folderId }) {
        if (this.folderId !== folderId) {
            this.onUpdate(
                this.eventEmitter({
                    patch: {
                        folder_id: folderId
                    },
                    data: {
                        folder: this.FolderService.getFolder(folderId)
                    }
                })
            );
        }
    }

}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-details-folder/thing-details-folder.controller.js